<div class="w-100 d-flex  modules-container">
  <section class="sidebar-section position-sticky top-0 bottom-0">
    <app-lateral-bar></app-lateral-bar>
  </section>
  <div class="content-section">
      <section class="navbar-container">
        <app-float-bar></app-float-bar>
      </section>
      <div class="content-container">
        <router-outlet></router-outlet>
      </div>
  </div>
</div>
